export default "__VITE_ASSET__DCZlrFQJ__"